/* ============================================================
   SCM Reviews — carosello a scorrimento + UX modulo. Nessuna libreria.
   Rispetta prefers-reduced-motion.
   ============================================================ */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Carosello ---------- */
  function initCarousel(root) {
    var track = root.querySelector(".scm-rev__track");
    if (!track) return;
    var prev = root.querySelector(".scm-rev__nav--prev");
    var next = root.querySelector(".scm-rev__nav--next");

    function step() {
      var card = track.querySelector(".scm-rev__card");
      var w = card ? card.getBoundingClientRect().width : 320;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 18;
      return w + gap;
    }
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });

    // Autoscroll dolce (solo se più card della larghezza visibile e niente reduce-motion)
    var auto = root.getAttribute("data-autoscroll") === "true";
    if (!auto || reduce) return;
    var timer = null;
    function start() {
      stop();
      timer = setInterval(function () {
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) {
          track.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          track.scrollBy({ left: step(), behavior: "smooth" });
        }
      }, 4200);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if (track.scrollWidth > track.clientWidth + 8) {
      start();
      root.addEventListener("mouseenter", stop);
      root.addEventListener("mouseleave", start);
      root.addEventListener("focusin", stop);
      track.addEventListener("touchstart", stop, { passive: true });
    }
  }

  /* ---------- Modulo: valore stelle + anteprima foto ---------- */
  function initForm(form) {
    // mostra il valore selezionato accanto a ogni gruppo di stelle
    form.querySelectorAll(".scm-revstars").forEach(function (group) {
      var out = group.parentNode.querySelector(".scm-revstars__val");
      group.addEventListener("change", function (e) {
        if (e.target && e.target.checked && out) out.textContent = e.target.value + " / 7";
      });
    });
    // anteprima foto
    var file = form.querySelector('input[type="file"]');
    var prev = form.querySelector(".scm-revform__preview");
    if (file && prev) {
      file.addEventListener("change", function () {
        var f = file.files && file.files[0];
        if (!f) { prev.classList.remove("show"); return; }
        prev.src = URL.createObjectURL(f);
        prev.classList.add("show");
      });
    }
  }

  function boot() {
    document.querySelectorAll(".scm-reviews[data-rev-root]").forEach(initCarousel);
    document.querySelectorAll("form[data-revform]").forEach(initForm);
  }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
